import { render, staticRenderFns } from "./socketStatus.vue?vue&type=template&id=1163bc06&scoped=true&"
import script from "./socketStatus.vue?vue&type=script&lang=js&"
export * from "./socketStatus.vue?vue&type=script&lang=js&"
import style0 from "./socketStatus.vue?vue&type=style&index=0&id=1163bc06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1163bc06",
  null
  
)

export default component.exports